module.exports = __webpack_public_path__ + "333a52a57a7d074ee26f8c96ad094901.png";